export default "__VITE_ASSET__3bc1e09f__"